// Dashboard constants — extracted from Dashboard.js (Feb 2026 refactor step 1).
//
// Kept as pure data + a single lookup map so Dashboard.js can shrink
// without any behavioural change. Icons here are consumed by both the
// dashboard grid and the category-picker modals.
import {
    Cpu, BrainCircuit, Briefcase, TrendingUp, GraduationCap, Film, Clapperboard,
    Heart, HeartPulse, Coffee, Newspaper, Zap, Target, UtensilsCrossed, ChefHat,
    Plane, MapPin, Compass, Folder, Music, Camera, BookOpen, Home, Globe,
    ShoppingBag, Palette, Code, Dumbbell, MessageCircle, Car, Baby, Dog, Gamepad2,
    Landmark, Stethoscope, Scale, Wine, Lightbulb, Flame, Flag, Trophy, Mic, Tv,
    Star, Rocket,
} from 'lucide-react';

// Icon-name → component lookup. Category docs carry a string `icon`
// field; the grid resolves it here to render the right lucide icon.
export const CATEGORY_ICONS = {
    'cpu': Cpu,
    'brain-circuit': BrainCircuit,
    'briefcase': Briefcase,
    'trending-up': TrendingUp,
    'graduation-cap': GraduationCap,
    'film': Film,
    'clapperboard': Clapperboard,
    'heart': Heart,
    'heart-pulse': HeartPulse,
    'coffee': Coffee,
    'newspaper': Newspaper,
    'zap': Zap,
    'target': Target,
    'utensils': UtensilsCrossed,
    'chef-hat': ChefHat,
    'plane': Plane,
    'map-pin': MapPin,
    'compass': Compass,
    'folder': Folder,
    'music': Music,
    'camera': Camera,
    'book': BookOpen,
    'home': Home,
    'globe': Globe,
    'shopping': ShoppingBag,
    'palette': Palette,
    'code': Code,
    'dumbbell': Dumbbell,
    'chat': MessageCircle,
    'car': Car,
    'baby': Baby,
    'dog': Dog,
    'gamepad': Gamepad2,
    'landmark': Landmark,
    'health': Stethoscope,
    'scale': Scale,
    'wine': Wine,
    'lightbulb': Lightbulb,
    'flame': Flame,
    'flag': Flag,
    'trophy': Trophy,
    'mic': Mic,
    'tv': Tv,
    'star': Star,
    'rocket': Rocket,
};

// Curated palette shown in the category create/edit modal.
export const CATEGORY_COLORS = [
    { name: 'Purple', value: '#8B5CF6' },
    { name: 'Green', value: '#10B981' },
    { name: 'Blue', value: '#3B82F6' },
    { name: 'Pink', value: '#EC4899' },
    { name: 'Red', value: '#EF4444' },
    { name: 'Amber', value: '#F59E0B' },
    { name: 'Indigo', value: '#6366F1' },
    { name: 'Teal', value: '#14B8A6' },
    { name: 'Orange', value: '#F97316' },
    { name: 'Cyan', value: '#06B6D4' },
];

// Ordered by usage frequency observed in prod categories — most
// popular first so the picker feels smart out of the gate.
export const ICON_OPTIONS = [
    { name: 'Folder', value: 'folder' },
    { name: 'AI', value: 'brain-circuit' },
    { name: 'Tech', value: 'cpu' },
    { name: 'Finance', value: 'trending-up' },
    { name: 'Briefcase', value: 'briefcase' },
    { name: 'Education', value: 'graduation-cap' },
    { name: 'Movies', value: 'clapperboard' },
    { name: 'Film', value: 'film' },
    { name: 'Health', value: 'heart-pulse' },
    { name: 'Heart', value: 'heart' },
    { name: 'Coffee', value: 'coffee' },
    { name: 'News', value: 'newspaper' },
    { name: 'Target', value: 'target' },
    { name: 'Zap', value: 'zap' },
    { name: 'Chef', value: 'chef-hat' },
    { name: 'Food', value: 'utensils' },
    { name: 'Travel', value: 'compass' },
    { name: 'Plane', value: 'plane' },
    { name: 'Pin', value: 'map-pin' },
    { name: 'Music', value: 'music' },
    { name: 'Camera', value: 'camera' },
    { name: 'Book', value: 'book' },
    { name: 'Home', value: 'home' },
    { name: 'Globe', value: 'globe' },
    { name: 'Shopping', value: 'shopping' },
    { name: 'Art', value: 'palette' },
    { name: 'Code', value: 'code' },
    { name: 'Fitness', value: 'dumbbell' },
    { name: 'Chat', value: 'chat' },
    { name: 'Car', value: 'car' },
    { name: 'Baby', value: 'baby' },
    { name: 'Pets', value: 'dog' },
    { name: 'Gaming', value: 'gamepad' },
    { name: 'Places', value: 'landmark' },
    { name: 'Medical', value: 'health' },
    { name: 'Justice', value: 'scale' },
    { name: 'Wine', value: 'wine' },
    { name: 'Ideas', value: 'lightbulb' },
    { name: 'Trending', value: 'flame' },
    { name: 'Flag', value: 'flag' },
    { name: 'Trophy', value: 'trophy' },
    { name: 'Podcast', value: 'mic' },
    { name: 'TV', value: 'tv' },
    { name: 'Star', value: 'star' },
    { name: 'Rocket', value: 'rocket' },
];
